import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Parser from "html-react-parser";
import Button from "../shared/button/Button";
import {
  Backdrop,
  ModalWrapper,
  Title,
  TitleText,
  Body,
  CloseButton,
  ButtonsWrapper,
} from "./styles/additional-information-modal-styles";
import Candidate from "../../apiResources/Candidate";

export const AdditionalInformationModal = (props: Props) => {
  const { candidate, onDismiss } = props;

  return (
    <Backdrop className="animated fadeIn">
      <ModalWrapper className="animated delay-1 fadeInDown">
        <Title>
          <TitleText>{`${candidate.fullName} - additional information`}</TitleText>
          <CloseButton onClick={onDismiss}>
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
        </Title>
        <Body>{Parser(candidate.additionalInfo)}</Body>
        <ButtonsWrapper>
          <Button primary buttonName="Close" onClickAction={onDismiss} />
        </ButtonsWrapper>
      </ModalWrapper>
    </Backdrop>
  );
};

type Props = {
  candidate: Candidate;
  onDismiss: () => void;
};

export default AdditionalInformationModal;
